import { Login } from "./Login";
import backgroundImage from "../../assets/background-login.png";
import logo from "../../assets/slogan.png";

export default function LoginConfigPage() {
  return (
    <Login
      style={style}
      logo={logo}
      // backgroundImage={backgroundImage}
    />
  );
}

export const style = {
  loginButton: {
    //login button 登录按钮
    buttonTextColor: "#FFFFFF",
    buttonBackgroundColor: "#2A7DF9",
    // login button disabled 登录按钮禁用
    buttonTextDisableColor: "#FFFFFF",
    buttonDisableBackgroundColor: "#2A7DF9",
  },
  codeButton: {
    textColor: '#2A7DF9',
  },
  userAgreement: {
    descriptionTextColor: "#C7C7C7",
    userAgreementTextColor: "#2A7DF9",
  },
  checkBox: {
    // check box checked color  勾选框勾选颜色
    checked: "#2A7DF9",
  },
  loginPage: {
    //login page background color 登录页背景色
    backgroundColor: "#ffffff",
  },
};
